<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-success"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base"
                :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                <div class="modal-base-head">
                    <p id="success_title" v-html="title"></p>
                </div>
                <div class="modal-base-body">
                    <p id="success_msg" v-html="message"></p>
                </div>
                <div class="modal-base-footer">
                    <PrimaryButton
                        btnId="success_ok_btn"
                        :btnMsg="btnOk"
                        @clickButton="clickOk()" />
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
import PrimaryButton from "../../Button/PrimaryButton.vue";
/**
 * @property {SuccessModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "SuccessModal",
    components: {
        PrimaryButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        controller: Object,
        modalId: String,
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        clickOk: function () {
            this.controller.cbOk.sendCallback({ tag: this.tag });
            this.$nextTick(() => {
                this.hide();
            });
        },
        show: function (config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk))
                this.btnOk = this.lbl.default.ok;
            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

#success_title {
    color: $color-gray;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
}

#success_msg {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: $color-gray;
}

%base-btn-txt {
    font-size: 1.5rem;
    // font-family: $heading;
}

.btn-wrapper {
    $fade_mass: url(../../../assets/share/tab/mass/mass-fade-menu@3x.png);
    $fase_prestige: url(../../../assets/share/tab/prestige/prestige-fade-menu@3x.png);
    @include btn-wrapper(100%, $fade_mass, $fase_prestige);
    box-shadow: none;

    &:nth-child(1) {
        margin-right: 7px;
    }

    &:nth-child(2) {
        margin-left: 7px;
    }

    &.mass {
        .btn-txt {
            @extend %base-btn-txt;
        }
    }

    &.prestige {
        .btn-txt {
            @extend %base-btn-txt;
        }
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-success {
    @extend %modal-base;

    .modal-dialog {
        max-width: 300px;
    }

    .modal-body {
        padding: 30px 20px;
    }
}
</style>
